/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Currency} from "./currency.zod";

export const Money = zod
  .object({
    amount: zod.number(),
    currency: Currency,
  })
  .describe("Monetary amount whose scale respects its Currency minor-unit precision.");

export type Money = zod.input<typeof Money>;
export type MoneyOutput = zod.output<typeof Money>;
